import React from "react";
import PropTypes from "prop-types";

import RouteMapPointWrapper from "../RouteMapPointWrapper";
import {createMapKey} from "../../utils";
import {isEqual} from "../../bl/routeService";
import RouteResponsePoint from "../../models/RouteResponsePoint";

export default class RouteMapPoints extends React.Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const {routeNotFound, visitedRoutePoints, showPassingCitiesInRouteDetails} = this.props;
    const segmentsEquals = isEqual(nextProps.visitedRoutePoints, visitedRoutePoints);
    const routeNotFoundEquals = nextProps.routeNotFound === routeNotFound;
    const showPassingCitiesInRouteDetailsEquals = nextProps.showPassingCitiesInRouteDetails === showPassingCitiesInRouteDetails;
    return !segmentsEquals || !routeNotFoundEquals || !showPassingCitiesInRouteDetailsEquals;
  }

  render() {
    const {routeNotFound, visitedRoutePoints, showPassingCitiesInRouteDetails} = this.props;

    return (
      <React.Fragment>
        {visitedRoutePoints.filter(visitedRoutePoint => showPassingCitiesInRouteDetails || 
          RouteResponsePoint.isKeyPoint(visitedRoutePoint.routePoint) || 
          RouteResponsePoint.isCustom(visitedRoutePoint.routePoint)).map(visitedRoutePoint =>
          <RouteMapPointWrapper visitedRoutePoint={visitedRoutePoint} key={createMapKey(visitedRoutePoint.routePoint)}
                                showPopup={!routeNotFound}/>)}
      </React.Fragment>
    );
  }
}

RouteMapPoints.propTypes = {
  excludeCity: PropTypes.func.isRequired,
  routeNotFound: PropTypes.bool.isRequired,
  visitedRoutePoints: PropTypes.array.isRequired
};
